export default __webpack_public_path__ + "static/media/subimage.1389f293.png";